import { WrapUpReason } from '@shared/graphql/types';

export class WrapupResult {
  constructor(public wrapups: Array<WrapUpReason>) {}
}
